module.exports = __webpack_public_path__ + "img/laptopman.5ebcf388.svg";